import invariant from 'tiny-invariant';

import { ScanType } from "./metadataLib";

// Link to landing page for tiling import campaign
export const importLandingPage = 'https://www.bandicootimaging.com/launch/goodbye-to-manual-tiling-for-pbr-texture-maps-and-digital-materials';

// This controls how many credits a new user is given when they create their account.
export const newUserCredits = 30;

export const SCAN_COST_CREDITS = {
  '2k': 5,
  '4k': 10,
  '6k': 15,
}

const SCAN_COST_CREDITS_DEFAULT = SCAN_COST_CREDITS['4k'];

export const CreditType = Object.freeze({
  USER_CREDIT: 'userCredit',
  SERVICE_CREDIT: 'serviceCredit',
});

export const importCostCredits = 3;

const stitchCostCredits = 10;

const servicedScanCostCredits = 1;

// Get the cost in credits to purchase a single product. For material products this does not include stitching
// inputs. Returns an object with the following fields:
//   costCredits: the list price in credits to purchase the product
//   billCredits: the cost in credits to bill the user for the product (0 if the product is unlocked)
//   creditType: the type of credit used for billing (either CreditType.USER_CREDIT or CreditType.SERVICE_CREDIT)
export function calculateProductCostCredits(productItem, isServiced) {
  const { scanType, texSize, isUnlocked } = productItem;
  let costCredits;
  if (isServiced) {
    costCredits = servicedScanCostCredits;
  } else {
    if (scanType === ScanType.CAMERA_SCAN) {
      invariant(texSize in SCAN_COST_CREDITS, `Invalid texture size: ${texSize}`);
      costCredits = SCAN_COST_CREDITS[texSize];
    } else if (scanType === ScanType.TEXTURE_IMPORT) {
      costCredits = importCostCredits;
    } else if (scanType === ScanType.STITCHED_MATERIAL) {
      costCredits = stitchCostCredits;
    } else {
      throw new Error(`Unknown scan type: ${scanType}`);
    }
  }
  const billCredits = isUnlocked ? 0 : costCredits;
  const creditType = isServiced ? CreditType.SERVICE_CREDIT : CreditType.USER_CREDIT;
  return { costCredits, billCredits, creditType };
}

// Determine if tiling is active for the given material and user
// tilingIncluded values.
export function tilingActive(materialTilingIncluded, userTilingIncluded) {
  return (
    (userTilingIncluded && materialTilingIncluded !== false) ||
    materialTilingIncluded === true
  );
}

// Return two dictionaries:
// 1. 'keys', a dict whose keys are gallery state field names, and whose values are
//    the editor settings which shopfront will bake into textures when changed.
// 2. 'defaults', a dict whose keys are gallery state field names, and whose values are
//    the editor/viewer's default values for those keys, used when not present.
//
// If you change the defaults here, please consider also changing the corresponding defaults in:
// - Burrow: steward.py
// - Bach: texport.py
export function getBakingParams() {
  return {
    keys: {
      meshRotateZDegrees: 'rotation',
      colorTemperature: 'colorTemperature',
      hue: 'hue',
      saturation: 'saturation',
      scaleMethod: 'scaleMethod',
      scaleFactor: 'scaleFactor',
    },
    defaults: {
      meshRotateZDegrees: 0,
      colorTemperature: 6500,
      hue: 0,
      saturation: 0,
      scaleMethod: 'knee',
      scaleFactor: 1.0,
    }
  };
}
